
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    text: {
        color: '#484848',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        margin: '0px',
        wordWrap: 'break-word',
        paddingTop: '0px',
        paddingBottom: '0px',
        display: 'inline'
    },
    size_small: {
        fontSize: '15px',
        lineHeight: '18px',
        letterSpacing: '0.2px'
    },
    size_micro: {
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.4px'
    },
    weight_bold: {
        fontWeight: 600
    },
    weight_light: {
        fontWeight: 300
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/cardCommonStyles.js